import { render } from "./CryptoPrice.vue?vue&type=template&id=2653f9fb&scoped=true"
import script from "./CryptoPrice.vue?vue&type=script&lang=ts"
export * from "./CryptoPrice.vue?vue&type=script&lang=ts"

import "./CryptoPrice.vue?vue&type=style&index=0&id=2653f9fb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2653f9fb"

export default script